import { render, staticRenderFns } from "./RepXMensajero.vue?vue&type=template&id=96c25722&scoped=true&"
import script from "./RepXMensajero.vue?vue&type=script&scoped=true&lang=js&"
export * from "./RepXMensajero.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./RepXMensajero.vue?vue&type=style&index=0&id=96c25722&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96c25722",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCardTitle,VCol,VIcon,VRow,VSelect,VSimpleTable,VSnackbar,VTextField})
